import { ConversionWindowEnum, OldConversionWindowEnum } from "../enums";

export const mapConversionWindow: any = {
    [OldConversionWindowEnum.OneDayClick]: ConversionWindowEnum.ONE_DAY_CLICK,
    [OldConversionWindowEnum.SevenDaysClick]: ConversionWindowEnum.SEVEN_DAYS_CLICK,
    [OldConversionWindowEnum.OneDayClickOrView]: ConversionWindowEnum.ONE_DAY_CLICK_OR_VIEW,
    [OldConversionWindowEnum.SevenDaysClickOrOneDayView]: ConversionWindowEnum.SEVEN_DAYS_CLICK_OR_ONE_DAY_VIEW,
}